export default __webpack_public_path__ + "static/media/s_linkedIn_d.16562e81.svg";